export interface IBuildOffsetQueryParams {
  offset?: number;
}

const build = (offset?: number) => {
  if (!offset || offset < 0) return '';
  return `OFFSET ${offset}`;
};

const parse = (query: string): number | undefined => {
  const match = query.match(/\bOFFSET\s+(\d+)/i);
  return match ? parseInt(match[1], 10) : undefined;
};

export { build as buildOffsetQuery, parse as parseOffsetQuery };
